import { render } from "./SwapInput.vue?vue&type=template&id=0f9e7c7f&scoped=true"
import script from "./SwapInput.vue?vue&type=script&lang=js"
export * from "./SwapInput.vue?vue&type=script&lang=js"

import "./SwapInput.vue?vue&type=style&index=0&id=0f9e7c7f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9e7c7f"]])

export default __exports__